import { Button } from "react-bootstrap";
import { num } from "../../../utils/num";
import "../../../Components/Table/Table.css";
import { Link, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import userAvatar from "../../../Assets/UserPage/avatar.png";
import { ImgsUrl, resolveImg } from "../../../Api/Api";
export default function AccessTable(props) {
  const navigation = useNavigate();

  // Maps the real backend target status ('open'/'pending' while running,
  // 'complete' once the goal is hit, 'deleted' once the category/admin
  // closes it out to start a new one for the same user) to a small colored
  // badge, so a closed-out target reads as clearly finished/deleted rather
  // than looking identical to an active one.
  const handleStatus = (value) => {
    switch (value) {
      case "complete":
      case "done":
        return (
          <div
            style={{
              backgroundColor: "#01B574",
              width: "fit-content",
              borderRadius: "20px",
            }}
            className="py-2 px-3 "
          >
            Completed
          </div>
        );

      case "deleted":
        return (
          <div
            style={{
              backgroundColor: "#56577A",
              width: "fit-content",
              borderRadius: "20px",
            }}
            className="py-2 px-3 "
          >
            Deleted
          </div>
        );

      case "failed":
        return (
          <div
            style={{
              backgroundColor: "#FF0000",
              width: "fit-content",
              borderRadius: "20px",
            }}
            className="py-2 px-3 "
          >
            Failed
          </div>
        );

      default:
        return (
          <div
            style={{
              backgroundColor: "#F7B546",
              width: "fit-content",
              borderRadius: "20px",
            }}
            className="py-2 px-3 "
          >
            Active
          </div>
        );
    }
  };

  return (
    <div>
      <div
        className="text-white text-start custom-table"
        style={{ overflowX: "scroll" }}
      >
        <div
          className="d-flex align-items-center justify-content-between mt-5 "
          style={{ borderBottom: "#56577A 1px solid" }}
        >
          <h6 className="col-md-2 text-grey ">User</h6>
          <h6 className="col-md-2 text-grey text-center">Coins Collected</h6>
          <h6 className="col-md-2 text-grey text-center">Time Consumed</h6>
          <h6 className="col-md-2 text-grey text-center">No.Lives</h6>
          <h6 className="col-md-2 text-grey text-center ">Date</h6>
          <h6 className="col-md-2 text-grey text-center">Status</h6>
          <h6 className="col-md-2 text-grey text-center">action</h6>
        </div>

        {props.loading ? (
          <div className="text-center mt-5">
            <div className="spinner-border text-light" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <h5 className="text-white mt-3">Loading targets...</h5>
          </div>
        ) : props.data?.length > 0 ? (
          <>
            {props?.data.map((ele) => (
              <div
                key={ele.id}
                className="d-flex align-items-center text-decoration-none text-white w-100 justify-content-between mt-3 pb-2 text-center"
                style={{ borderBottom: "#56577A 1px solid" }}
              >
                <div className=" col-md-2 gap-2 text-start d-flex align-items-center">
                  <img
                    className="col-md-2"
                    src={
                      ele?.user?.img
                        ? resolveImg(ele.user.img)
                        : userAvatar
                    }
                    alt=""
                    style={{
                      height: "63.8px",
                      width: "36.39px",
                      objectFit: "cover",
                    }}
                  />
                  <div>
                    <p className="m-0">{ele?.user?.name ? `@${ele.user.name}` : "Unknown"}</p>
                    <p className="text-grey m-0">
                      {ele?.user?.nick_name || "Unknown"}
                    </p>
                  </div>
                </div>
                <div className=" col-md-2 d-flex align-items-center justify-content-center ">
                  <div className="py-2 px-3 rounded" style={{ backgroundColor: "#01B574" }}>
                    {num(ele?.coins)}
                  </div>
                </div>
                <div className=" col-md-2 d-flex align-items-center justify-content-center">
                  <div className="py-2 px-3 rounded" style={{ backgroundColor: "#F7B546" }}>
                    {ele?.hours || "00:00"}
                  </div>
                </div>
                <div className="col-md-2 d-flex align-items-center justify-content-center">
                  <div className="py-2 px-3 rounded" style={{ backgroundColor: "#8B66B7" }}>
                    {ele?.lives || "0"}
                  </div>
                </div>
                <h6 className="col-md-2  text-center">
                  {dayjs(ele?.start_time).format("DD/MM/YYYY")}
                </h6>
                <div className="col-md-2 d-flex align-items-center justify-content-center">
                  {handleStatus(ele?.status)}
                </div>
                <div className="col-md-2 d-flex align-items-center  gap-3 d-flex align-items-center justify-content-center">
                  <Button
                    onClick={() => {
                      props.setSelectedTarget(ele);
                      props.setOpenTarget(true);
                    }}
                    className="border-0 text-uppercase text-white rounded bg-custom-gray "
                  >
                    Open
                  </Button>
                </div>
              </div>
            ))}
          </>
        ) : (
          <h1 className="text-center mt-5">No Data Yet</h1>
        )}
      </div>
    </div>
  );
}
